"use client";

import { createContext, type ReactNode, useContext, useState } from "react";

interface BreadcrumbContextType {
	customBreadcrumbTitle: string | null;
	setCustomBreadcrumbTitle: (title: string | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(
	undefined,
);

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
	const [customBreadcrumbTitle, setCustomBreadcrumbTitle] = useState<
		string | null
	>(null);

	return (
		<BreadcrumbContext.Provider
			value={{ customBreadcrumbTitle, setCustomBreadcrumbTitle }}
		>
			{children}
		</BreadcrumbContext.Provider>
	);
}

export function useBreadcrumbContext() {
	const context = useContext(BreadcrumbContext);
	if (context === undefined) {
		throw new Error(
			"useBreadcrumbContext must be used within a BreadcrumbProvider",
		);
	}
	return context;
}
